<template>
	<div class="ui-pagination">
		<div class="ui-pagination-pageSize">
			<label>{{ $t('pagination.pageSize') }}</label>
			<select v-model="pageSize">
				<option>10</option>
				<option>25</option>
				<option>50</option>
				<option>100</option>
			</select>
		</div>

		<div v-if="pagination.totalPages > 1" class="ui-pagination-items">
			<div :class="['ui-pagination-item', {'ui-pagination-item--disabled': isOnFirst}]" @click="goToPage(pagination.currentPage - 1)">
				<i class="ui-pagination-icon ui-pagination-icon--flip fas fa-play" />
			</div>
			<div v-if="showFirstElispis" class="ui-pagination-item" @click="goToPage(1)">
				<span>1</span>
			</div>
			<div v-if="showFirstElispis" class="ui-pagination-item ui-pagination-itemElipsis">
				<span>...</span>
			</div>
			<div v-for="number in getNumbers" :key="number"
				:class="['ui-pagination-item', { 'ui-pagination-item--current':  number === pagination.currentPage}]"
				@click="goToPage(number)"
			>
				<span>{{ number }}</span>
			</div>
			<div v-if="showLastElispis" class="ui-pagination-item ui-pagination-itemElipsis">
				<span>...</span>
			</div>
			<div v-if="showLastElispis" class="ui-pagination-item" @click="goToPage(pagination.totalPages)">
				<span>{{ pagination.totalPages }}</span>
			</div>
			<div :class="['ui-pagination-item', { 'ui-pagination-item--disabled': isOnLast }]" @click="goToPage(pagination.currentPage + 1)">
				<i class="ui-pagination-icon fas fa-play" />
			</div>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		pagination: {
			type: Object
		}
	},

	data: () => ({
		pageSize: 10
	}),

	watch: {
		pageSize() {
			this.$emit('on-update-pagesize', this.pageSize);
		}
	},

	computed: {
		isOnFirst() {
			return this.pagination.currentPage === 1;
		},

		isOnLast() {
			return this.pagination.currentPage === this.pagination.totalPages;
		},

		showFirstElispis() {
			return this.pagination.currentPage > this.pagination.totalPages + 1;
		},

		showLastElispis() {
			return this.pagination.currentPage < this.pagination.totalPages - 1;
		},

		getNumbers() {
			const totalNumbers = this.pagination.totalPages;
			const arr = Array(totalNumbers).fill(0).map((_, i) => i + 1);
			const currentNumber = this.pagination.currentPage;
			const currentIndex = arr.findIndex(x => x === currentNumber);
			const beforeNumbers = [];
			const afterNumbers = [];

			if (arr[currentIndex - 1]) {
				beforeNumbers.push(arr[currentIndex - 1]);
			}

			if (arr[currentIndex + 1]) {
				afterNumbers.push(arr[currentIndex + 1]);
			}

			return [
				...beforeNumbers,
				currentNumber,
				...afterNumbers
			];
		}
	},

	created() {
		this.pageSize = this.pagination.pageSize;
	},

	methods: {
		goToPage(number) {
			this.$emit('on-update-page', number);
		}
	}
};
</script>

<style lang="scss">
.ui-pagination {
	display: flex;
	justify-content: flex-end;
}

.ui-pagination-pageSize {
	height: 26px;
	display: flex;
	align-items: center;
	margin-right: 5px;

	label {
		margin-right: 4px;
		font-size: 12px;
	}
}

.ui-pagination-items {
	display: flex;
}

.ui-pagination-item {
	font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 26px;
	height: 26px;
	background-color: #4d535d;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		transition: background-color 0.3s ease;
		background-color: lighten(#4d535d, 10%);
	}

	&:first-child {
		border-bottom-left-radius: 4px;
		border-top-left-radius: 4px;
	}

	&:last-child {
		border-bottom-right-radius: 4px;
		border-top-right-radius: 4px;
	}
}

.ui-pagination-item--current {
	pointer-events: none;
	color: #e66f1f;
}

.ui-pagination-item--disabled {
	pointer-events: none;

	opacity: 0.5;
}

.ui-pagination-itemElipsis {
	pointer-events: none;
}



.ui-pagination-icon {
	color: white;
	font-size: 12px;
}

.ui-pagination-icon--flip {
	transform: scaleX(-0.8);
}
</style>
